import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { InstitutionsService } from '../../services/institutions.service';

@Component({
  selector: 'shared-dropdown-institutions',
  templateUrl: './dropdow-institutions.component.html',
  styleUrls: ['./dropdow-institutions.component.scss'],
})
export class DropdowInstitutionsComponent implements OnInit {
  @Input() formControlName: string = '';
  @Input() errorClass: string = '';
  @Output() selectedValueChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedValue: any;

  public institutions: any = [];
  constructor(private institutionService: InstitutionsService) {}

  ngOnInit(): void {
    this.getInstitutions();
  }

  getInstitutions() {
    this.institutionService.getInstitutions().subscribe({
      next: (response) => {
        this.institutions = response;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onDropdownChange(event: any) {
    this.selectedValueChange.emit(this.selectedValue);
  }
}
